import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { StationMetrics } from '../../../services/ocpp/types';
import { formatNumber } from '../../../shared/utils/numberFormat';
import { MASK } from '../../../shared/utils/mask';

interface StationMetricsTableProps {
  metrics: StationMetrics[];
  loading: boolean;
  /** Hide mode: renders every figure as a mask. */
  hidden?: boolean;
}

export const StationMetricsTable = memo(function StationMetricsTable({
  metrics,
  loading,
  hidden = false,
}: StationMetricsTableProps) {
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="station-metrics-section">
        <h3 className="station-metrics-title">{t('dashboard.metrics.stationPerformance')}</h3>
        <div className="skeleton" style={{ height: '200px', borderRadius: '0.75rem' }} />
      </div>
    );
  }

  if (metrics.length === 0) {
    return null;
  }

  return (
    <div className="station-metrics-section">
      <h3 className="station-metrics-title">{t('dashboard.metrics.stationPerformance')}</h3>
      <table className="station-metrics-table">
        <thead>
          <tr>
            <th scope="col">{t('dashboard.metrics.stationName')}</th>
            <th scope="col">{t('dashboard.metrics.tableSessions')}</th>
            <th scope="col">{t('dashboard.metrics.tableEnergy')}</th>
            <th scope="col">{t('dashboard.metrics.tableRevenue')}</th>
            <th scope="col">{t('dashboard.metrics.tableIdleRevenue')}</th>
          </tr>
        </thead>
        <tbody>
          {metrics.map((station) => (
            <tr key={station.stationId}>
              <td className="station-metrics-address" title={station.address}>
                {station.address || station.idTag}
              </td>
              <td style={{ fontVariantNumeric: 'tabular-nums' }}>{station.sessionCount}</td>
              <td className="station-metrics-value" style={{ fontVariantNumeric: 'tabular-nums' }}>{hidden ? MASK : formatNumber(station.kwh)}</td>
              <td className="station-metrics-value" style={{ fontVariantNumeric: 'tabular-nums' }}>{hidden ? MASK : formatNumber(station.revenue)}</td>
              <td className="station-metrics-value" style={{ fontVariantNumeric: 'tabular-nums' }}>{hidden ? MASK : formatNumber(station.idleRevenue ?? 0)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
});

export default StationMetricsTable;
